import defaults from 'lodash/defaults'

import Icon from 'ol/style/Icon'

export default function (styleOptions) {
  const options = defaults(styleOptions, {
    anchor: [0.5, 0.5],
    anchorXUnits: 'fraction',
    anchorYUnits: 'fraction',
  })
  return new Icon({
    ...options,
  })
}
